export const CONTRACT_STATUSES = {
  INCOMPLETE: "incomplete",
  COMPLETED: "completed",
  PENDING: "pending"
};
